(() => {
  const PARAM = "write_review";
  const HASH = "#judgeme";
  const params = new URLSearchParams(window.location.search);
  const hasParam = params.get(PARAM) === "1";
  const hasHash =
    window.location.hash === HASH ||
    window.location.hash === "#judgeme_product_reviews";

  if (!hasParam && !hasHash) return;

  let opened = false;
  let attempts = 0;
  const maxAttempts = 150;

  const cleanUrl = () => {
    params.delete(PARAM);
    const search = params.toString();
    const nextUrl = `${window.location.pathname}${search ? `?${search}` : ""}${window.location.hash}`;
    window.history.replaceState({}, "", nextUrl);
  };

  const ensureHash = () => {
    if (window.location.hash !== HASH) {
      window.location.hash = "judgeme";
    }
  };

  const isModalOpen = () =>
    Boolean(
      document.querySelector(
        ".jdgm-write-review-modal.jdgm-write-review-modal--visible, .jdgm-write-review-modal[aria-hidden='false'], .jdgm-write-review-modal:not(.jdgm-hidden):not([hidden])"
      )
    );

  const triggerWriteReview = () => {
    const jdgm = window.jdgm;
    if (!jdgm) return false;

    if (typeof jdgm.$ === "function") {
      const links = jdgm.$(".jdgm-write-rev-link");
      if (links.length) {
        links.first().trigger("click");
        return true;
      }
    }

    const link = document.querySelector(".jdgm-write-rev-link");
    if (link instanceof HTMLElement) {
      link.click();
      return true;
    }

    if (typeof jdgm.openForm === "function" && typeof jdgm.visibleRevWidget === "function") {
      const widget = jdgm.visibleRevWidget();
      if (widget && widget.length) {
        jdgm.openForm(widget);
        return true;
      }
    }

    return false;
  };

  const openWriteReview = () => {
    if (opened || isModalOpen()) {
      opened = true;
      cleanUrl();
      return true;
    }

    ensureHash();
    triggerWriteReview();

    if (isModalOpen()) {
      opened = true;
      cleanUrl();
      return true;
    }

    return false;
  };

  const tryOpen = () => {
    if (openWriteReview()) return;

    attempts += 1;
    if (attempts < maxAttempts) {
      window.setTimeout(tryOpen, 100);
    }
  };

  const observer = new MutationObserver(() => {
    openWriteReview();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 20000);

  document.addEventListener("jdgm.doneSetup", tryOpen);
  document.addEventListener("doneSetupReviewForm", tryOpen);
  window.addEventListener("load", tryOpen);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryOpen);
  } else {
    tryOpen();
  }

  [500, 1500, 3000, 5000, 8000].forEach((delay) => {
    window.setTimeout(tryOpen, delay);
  });
})();
